
import React, { useEffect } from 'react';
import '../style/App.css';
import UserInfo from './UserInfo';
import Translate from './Translate';
import { useTwitterContext } from '../TwitterContext';
import { faTrash, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const Comment = ({ comment }) => {
  const [curComment, setCurComment] = React.useState(comment);
  const [user, setUser] = React.useState(null);
  const { accessToken, curUser } = useTwitterContext();
  const [isDeleted, setIsDeleted] = React.useState(false);
  useEffect(() => {
    async function getUser() {
      const data = await fetch(`${process.env.REACT_APP_API_URL}/users/${curComment.userId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const user = await data.json();
      setUser(user);
    }
    getUser();
  }, [curComment]);

  async function DeleteComment() {
    await fetch(`${process.env.REACT_APP_API_URL}/comments/${curComment.id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    setIsDeleted(true);
  }

  function SwitchEditPanel() {
    let text = document.getElementById("tweet-content-text");
    if (text.contentEditable === "true") {
      text.contentEditable = false;
      text.style.border = "none";
      let button = document.getElementsByClassName("edit-button")[0];
      button.remove();
      return;
    }
    text.contentEditable = true;
    text.focus();
    text.style.border = "1px solid #ccc";
    let content = document.getElementsByClassName("tweet-content")[0];
    let button = document.createElement("button");
    button.innerHTML = "Save";
    button.onclick = EditComment;
    button.className = "edit-button";
    content.appendChild(button);
  }

  async function EditComment() {
    const updatedText = document.getElementById("tweet-content-text").innerText;
    const data = await fetch(`${process.env.REACT_APP_API_URL}/comments/${curComment.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        text: updatedText,
      }),
    });
  }

  if (isDeleted) {
    return null;
  }
  
  return (
    <div className="tweet">
      <UserInfo info={user} />
      <div className="tweet-content">
        <p id="tweet-content-text">{curComment.text}</p>
        <Translate text={curComment.text} />
        {/* {user && curUser && user.id === Number(curUser.id) && 
        <FontAwesomeIcon className="tweet-buttom-detail"  icon={faPenToSquare} onClick={SwitchEditPanel} />} */}
        {/* {user && curUser && user.id === Number(curUser.id) && 
        <FontAwesomeIcon className="tweet-buttom-detail"  icon={faTrash} onClick={DeleteComment} />} */}
      </div>
    </div>
  );
};

export default Comment;